export const defaultTo = <T>(value: T, defaultValue: T) => value || defaultValue;
export const emptyString = (value = "") => value || "";
export const zeroNumber = (value = 0) => value;
